export default __webpack_public_path__ + "static/media/drop-in.25e1151b.png";